import * as React from 'react';
import type { TenantBillingConfigurationStatus } from '@klareospace/pharos-lib-types';
import { TENANT_BILLING_CONFIGURATION_STATUS } from '@klareospace/pharos-lib-types';

import { StatusBadge } from '../status-badge';

// ─── Constants ────────────────────────────────────────────────────────────────

export const BILLING_CONFIGURATION_STATUS_STYLES: Record<TenantBillingConfigurationStatus, string> = {
  [TENANT_BILLING_CONFIGURATION_STATUS.ACTIVE]: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  [TENANT_BILLING_CONFIGURATION_STATUS.INACTIVE]: 'bg-gray-100 text-gray-500 border-gray-200',
  [TENANT_BILLING_CONFIGURATION_STATUS.PENDING]: 'bg-amber-100 text-amber-800 border-amber-200',
  [TENANT_BILLING_CONFIGURATION_STATUS.UPCOMING]: 'bg-accent text-primary border-primary/20',
};

// ─── Types ────────────────────────────────────────────────────────────────────

export interface BillingConfigurationStatusBadgeProps {
  /** The translated label to show inside the badge */
  label: string;
  /** The tenant billing configuration status to display */
  status: TenantBillingConfigurationStatus;
}

// ─── Component ────────────────────────────────────────────────────────────────

export function BillingConfigurationStatusBadge({
  label,
  status,
}: BillingConfigurationStatusBadgeProps): React.JSX.Element {
  return (
    <StatusBadge className="font-medium" label={label} status={status} styles={BILLING_CONFIGURATION_STATUS_STYLES} />
  );
}
